import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "Voici votre token de connexion. Ce code est confidentiel ", -1)
const _hoisted_2 = { class: "main-layout" }
const _hoisted_3 = {
  class: "flex col",
  style: {"width":"400px","max-width":"80vw"}
}
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "flex col g24" }
const _hoisted_6 = { class: "flex justify-between" }
const _hoisted_7 = { class: "flex align-center" }
const _hoisted_8 = {
  class: "flex",
  style: {"gap":"12px"}
}
const _hoisted_9 = { class: "flex col g24" }
const _hoisted_10 = { class: "flex wrap" }
const _hoisted_11 = { class: "flex wrap" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h1", { class: "subtitle" }, "Stores", -1)
const _hoisted_13 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_14 = { class: "grid" }
const _hoisted_15 = { class: "subtitle" }
const _hoisted_16 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeTextarea = _resolveComponent("SeTextarea")!
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_SeModal = _resolveComponent("SeModal")!
  const _component_NavHeader = _resolveComponent("NavHeader")!
  const _component_SeIllustration = _resolveComponent("SeIllustration")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_SeInput = _resolveComponent("SeInput")!
  const _component_WideCard = _resolveComponent("WideCard")!
  const _component_SeDropdownFilter = _resolveComponent("SeDropdownFilter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SeModal, {
      ref: "tokenModal",
      title: "Token"
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        (_ctx.token != null)
          ? (_openBlock(), _createBlock(_component_SeTextarea, {
              key: 0,
              style: {"height":"200px"},
              defaultValue: _ctx.token.result
            }, null, 8, ["defaultValue"]))
          : _createCommentVNode("", true),
        _createVNode(_component_SeButton, {
          onPress: _ctx.copyToken,
          icon: "/ico/copy.svg"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Copier")
          ]),
          _: 1
        }, 8, ["onPress"])
      ]),
      _: 1
    }, 512),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SeModal, {
        ref: "pwdModal",
        title: _ctx.Lang.getI18N('change-password')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(_ctx.Lang.getI18N("relogin-warning")), 1),
            _createVNode(_component_SeButton, {
              onPress: _ctx.disconnectForPasswordChange,
              class: "w100"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Ok")
              ]),
              _: 1
            }, 8, ["onPress"])
          ])
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(_component_NavHeader, {
        backButton: "true",
        subtitle: _ctx.state.selectedAccount!.role == _ctx.Role.Admin
      ? _ctx.Lang.getI18N(_ctx.Role.Customer)
      : _ctx.Lang.getI18N(_ctx.state.selectedAccount!.role)
      ,
        title: _ctx.state.selectedAccount!.name + ' ' + _ctx.state.selectedAccount!.surname
      }, null, 8, ["subtitle", "title"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_SeIllustration, {
                onFilePick: _ctx.onIllustrationChange,
                src: _ctx.state.selectedAccount!.illustration_url == null
              ? 'ico/account.svg'
              : _ctx.state.selectedAccount!.illustration_url.get()
              
              }, null, 8, ["onFilePick", "src"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.state.selectedAccount.ref.id == _ctx.user.ref.id)
                ? (_openBlock(), _createBlock(_component_SeButton, {
                    key: 0,
                    onPress: _ctx.openPasswordModal,
                    icon: "ico/edit.svg"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("change-password")), 1)
                    ]),
                    _: 1
                  }, 8, ["onPress"]))
                : _createCommentVNode("", true),
              (_ctx.user.role == _ctx.Role.Distributor || _ctx.user.role == _ctx.Role.Admin)
                ? (_openBlock(), _createBlock(_component_SeButton, {
                    key: 1,
                    ref: "tokenBtn",
                    icon: "/ico/accounts.svg",
                    onPress: _ctx.createLoginToken
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("create-login-token")), 1)
                    ]),
                    _: 1
                  }, 8, ["onPress"]))
                : _createCommentVNode("", true),
              _createVNode(_component_ToggleSwitch, {
                auto: "true",
                modelValue: _ctx.state.selectedAccount!.active,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.selectedAccount!.active) = $event)),
                ref: "switch"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("active")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_SeButton, {
                onPress: _ctx.updateAccount,
                ref: "modifyBtn",
                icon: "/ico/save.svg",
                tooltip: _ctx.Lang.getI18N('save')
              }, null, 8, ["onPress", "tooltip"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_SeInput, {
                ref: "name",
                placeholder: _ctx.Lang.getI18N('name'),
                modelValue: _ctx.state.selectedAccount!.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.selectedAccount!.name) = $event))
              }, null, 8, ["placeholder", "modelValue"]),
              _createVNode(_component_SeInput, {
                ref: "surname",
                placeholder: _ctx.Lang.getI18N('surname'),
                modelValue: _ctx.state.selectedAccount!.surname,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.selectedAccount!.surname) = $event))
              }, null, 8, ["placeholder", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_SeInput, {
                ref: "email",
                placeholder: _ctx.Lang.getI18N('email'),
                readonly: true,
                modelValue: _ctx.state.selectedAccount!.email,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.selectedAccount!.email) = $event))
              }, null, 8, ["placeholder", "modelValue"]),
              _createVNode(_component_SeInput, {
                ref: "phoneNumber",
                placeholder: _ctx.Lang.getI18N('phone-number'),
                modelValue: _ctx.state.selectedAccount!.phone_number,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.selectedAccount!.phone_number) = $event))
              }, null, 8, ["placeholder", "modelValue"])
            ])
          ])
        ]),
        _hoisted_12,
        (_ctx.stores.length == 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.Lang.getI18N("no-elements")), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stores, (store) => {
            return (_openBlock(), _createBlock(_component_WideCard, {
              key: store.ref?.id,
              icon: "/ico/store.svg",
              title: store.name,
              obj: store,
              redirectPage: "store"
            }, {
              subtitle: _withCtx(() => [
                _createTextVNode(_toDisplayString(store.address) + " - " + _toDisplayString(store.city), 1)
              ]),
              footer: _withCtx(() => []),
              _: 2
            }, 1032, ["title", "obj"]))
          }), 128))
        ]),
        (
        _ctx.state.selectedAccount.role == _ctx.Role.Manager &&
        _ctx.state.selectedAccount == _ctx.user
      )
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("template", null, [
          _createElementVNode("h1", _hoisted_15, _toDisplayString(_ctx.Lang.getI18N("store-tags")), 1),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_SeDropdownFilter, {
              ref: "managerStoreTags",
              items: _ctx.storeTags,
              labelFunction: (tag) => tag.name,
              descriptionFunction: (tag) => (<any>tag).databaseName
            }, null, 8, ["items", "labelFunction", "descriptionFunction"])
          ])
        ], 512), [
          [_vShow, false]
        ])
      ])
    ])
  ], 64))
}